<template>
    <div
        class="min-h-screen flex items-center justify-center bg-theme-canvas px-4"
    >
        <div
            class="w-full max-w-md bg-theme-card border border-theme-border rounded-2xl p-8 flex flex-col items-center gap-4 text-center"
        >
            <div
                v-if="isLoading"
                class="w-10 h-10 rounded-full border-4 border-theme-border border-t-theme-primary animate-spin"
            ></div>
            <h1 class="text-xl font-semibold" :class="titleClass">
                {{ title }}
            </h1>
            <p v-if="description" class="text-sm text-theme-muted">
                {{ description }}
            </p>
            <div
                v-if="$scopedSlots.actions"
                class="flex flex-wrap justify-center gap-2"
            >
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
const VARIANTS = ["checking", "redirecting", "success", "rejected", "pending"];

const TITLE_CLASSES = {
    success: "text-theme-success",
    rejected: "text-theme-danger",
    pending: "text-theme-warning"
};

export default {
    name: "PaymentResultCard",
    props: {
        variant: {
            type: String,
            default: "checking",
            validator: (value) => VARIANTS.includes(value)
        },
        title: { type: String, default: "" },
        description: { type: String, default: "" }
    },
    computed: {
        isLoading() {
            return (
                this.variant === "checking" || this.variant === "redirecting"
            );
        },
        titleClass() {
            return TITLE_CLASSES[this.variant] || "text-theme-base";
        }
    }
};
</script>
